import { style, media } from 'typestyle'
import { important } from 'csx'
export const pb16mdi = style(media({ maxWidth: 768 }, { paddingBottom: important('16px') }))
